import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/partners/new/loading';

export const Route = createFileRoute('/_private/settings/partners/new')({
  component: Loading,
});
